import classNames from 'classnames';

import { Typography } from '@/components';
import { getRel, getTarget } from '@/theme/shared/utils';

import styles from './MenuSection.module.scss';

import type { FooterMenuItem, FooterMenuSection } from '../../types';

interface MenuSectionProps {
  section: FooterMenuSection;
  className?: string;
}

export function MenuSection({ section, className }: MenuSectionProps) {
  return (
    <div className={classNames(styles.menuColumn, className)}>
      <Typography
        variant="label"
        size="small"
        tagName="span"
        className={styles.menuHeading}
        color="var(--color-text-link-default-light)"
      >
        {section.title}
      </Typography>
      <ul className={styles.menuList}>
        {section.items.map((item: FooterMenuItem) => {
          const target = getTarget(item.target);

          return (
            <li key={item.id}>
              <a href={item.url || '#'} target={target} rel={getRel(target)}>
                <Typography variant="body" singleLine size="medium" tagName="span" color="inherit">
                  {item.label}
                </Typography>
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
